import React, { useState } from "react";

import { twMerge } from "tailwind-merge";

import { LoadingIndicator } from "./mini-loading-indicator/mini-loading-indicator";

export type ConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
  className?: string;
};

export const ConfirmationSlideout = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  className,
}: ConfirmationModalProps) => {
  const [loading, setLoading] = useState(false);
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={twMerge(
        "w-full flex flex-row items-center justify-between bg-sun-2  rounded-sm py-1 px-2",
        className,
      )}
    >
      {title}
      <div className="space-x-1 h-6 flex flex-row items-center">
        {loading ? (
          <LoadingIndicator />
        ) : (
          <>
            <button
              className="text-xs font-bold text-mars px-1 py-1 hover:bg-white rounded"
              onClick={async () => {
                setLoading(true);
                await onConfirm();
                setLoading(false);
              }}
            >
              YES
            </button>
            <button
              className="text-xs font-bold text-primary px-1 py-1 hover:bg-white rounded"
              onClick={onClose}
            >
              NO
            </button>
          </>
        )}
      </div>
    </div>
  );
};
